// Module
var code = `<div id="locationModal" class="modal-dialog">
	<div class="modal-content">
		<div class="modal-header">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title" data-bind="text: title"></h4>
		</div>
		<div class="modal-body">
			<form data-bind="submit: function(){ return false; }">
				<input class="form-control" data-bind="textInput: search, hasfocus: hasSearchFocus, attr:{ placeholder: placeholder }">
			</form>
			<!-- ko if: (!isBusy() && locations() && locations().length > 0) -->
			<div class="results-list" data-bind="foreach: locations, infiniteScroll: true, css:{ multi: \$root.selectMode() == 'multiple' }">
				<a href="javascript:void(0);" data-bind="
                    click: function(obj, e){ return \$root.clickedLocation(obj, e); },
                    css: { 
                        selected: (\$root.selectMode() != 'multiple' && \$index()==\$root.selected()),
                        checked: \$root.selection().find(function(selIt){ return selIt._id == \$data._id; })
                     }">
					<!-- ko if: (\$root.selectMode() != "multiple" && \$index()==\$root.selected()) -->
					<span class="hint text-muted">↵&nbsp;Enter to accept</span>
					<!-- /ko -->

					<div class="media-body">
						<h4 data-bind="text: name"></h4>
						<div class="text-muted" data-bind="text: \$data.address || '&nbsp;'"></div>
					</div>
					<!-- ko if: \$root.selectMode() == "multiple" -->
					<div class="media-right">
						<label class="el-checkbox" data-bind="attr:{ for: 'chk' + \$index() }">
							<input type="checkbox" data-bind="checkedValue: \$data,  checkedInArray: \$root.selection, checkedComparer: function(a,b){ return a._id == b._id; }, attr: { name: 'chk' + \$index() }">
							<span class="el-checkbox-style"></span>
						</label>
					</div>
					<!-- /ko -->
				</a>
				<!-- ko if: \$root.loadMore() && \$index() == \$root.locations().length -1 -->
				<button class="btn btn-secondary btn-block" data-bind="click:function(){ \$root.clickedLoadMore() }, disabled: \$root.isLoadingMore(), text:(\$root.isLoadingMore()?'Loading...':'Load more')"></button>
				<!-- /ko -->
			</div>
			<!-- /ko -->
			<!-- ko if: isEmpty() && !isBusy() -->
			<div class="results-empty">
				<p class="lead" data-bind="html: \$root._getEmptyMessage()"></p>
			</div>
			<!-- /ko -->
			<!-- ko if: isBusy() -->
			<div class="results-loading">
				<div class="loader-sm"></div>
			</div>
			<!-- /ko -->
		</div>
		<!-- ko if: (selectMode() == "multiple") -->
		<div class="modal-footer">
			<a href="#" class="btn btn-secondary" data-bind="click: function(){ close(); }">Cancel</a>&nbsp;
			<button class="btn btn-primary" data-bind="attr: {  disabled: \$root.selection().length == 0 }, click: \$root.clickedAddSelection, text: \$root.selectionText"></button>
		</div>
		<!-- /ko -->
	</div>
</div>
`;
// Exports
export default code;